module.exports = __webpack_public_path__ + "static/media/RHA_Homecoming.7b15931b.jpg";